import BaseComponent from 'foundation/base-component';
import EmailCaptureBaseFormComponent from './email-capture-base-form.component';
import EmailCaptureCheckEmailFormComponent from './email-capture-check-email-form.component';
import Modal from '../../../general/js/modal';

export default class EmailCaptureComponent extends BaseComponent {
    constructor(element, id, options) {
        super(element, id);

        this._successUserDataSent = null;
        this._successUserCaptured = null;
        this._errorUserCaptured = null;
        this._successEmailChecked = null;
        this._errorEmailChecked = null;

        this._captureUrl = options.captureUrl;
        this._checkEmailUrl = options.checkEmailUrl;

        this.init();
    }

    static getRequiredRefs() {
        return [
            'baseForm',
            'checkEmailForm',
            'showEmailFormTrigger',
            'showBaseFormTrigger'
        ];
    }

    init() {
        this.form = new EmailCaptureBaseFormComponent(this.refs.baseForm, 'form', {
            action: this._captureUrl,
            onBeforeSubmit: this._onBeforeCaptureSubmit,
            onSuccess: this._onSuccessUserCaptured,
            onError: this._onErrorUserCaptured,
            transformData: (data) => {
                return {
                    firstName: data.firstName,
                    lastName: data.lastName,
                    email: data.email,
                    agreeToMarketing: data.agreeToMarketing,
                    agreeToPartners: data.agreeToPartners,
                    agreeToPrivacyPolicy: data.agreeToPrivacyPolicy,
                };
            }
        });
        this.checkEmailForm = new EmailCaptureCheckEmailFormComponent(this.refs.checkEmailForm, 'form', {
            action: this._checkEmailUrl,
            onSuccess: this._onSuccessEmailChecked,
            onError: this._onErrorEmailChecked,
            showSpinner: true
        });

        this.refs.showEmailFormTrigger.addEventListener('click', this.showCheckEmailForm);
        this.refs.showBaseFormTrigger.addEventListener('click', this.showBaseForm);

        this.modal = new Modal(this.element);
    }

    showCheckEmailForm = () => {
        this.element.classList.add('check-email-visible');
    }

    showBaseForm = () => {
        this.element.classList.remove('check-email-visible');
    }

    _onBeforeCaptureSubmit = (data) => {
        this.modal.close();
        this._successUserDataSent(data);
    }

    _onSuccessUserCaptured = (response) => {
        this._successUserCaptured(response);
    }

    _onErrorUserCaptured = (error) => {
        this._errorUserCaptured(error);
    }

    _onSuccessEmailChecked = (response) => {
        this.modal.close();
        this._successEmailChecked(response);
    }

    _onErrorEmailChecked = (error) => {
        this.modal.close();
        this._errorEmailChecked(error);
    }

    capture(successUserDataSent, successUserCaptured, errorUserCaptured, successEmailChecked, errorEmailChecked) {
        this._successUserDataSent = successUserDataSent;
        this._successUserCaptured = successUserCaptured;
        this._errorUserCaptured = errorUserCaptured;
        this._successEmailChecked = successEmailChecked;
        this._errorEmailChecked = errorEmailChecked;
        this.modal.open();
    }
}
